import React, {useEffect, useState} from 'react';
import {Image, Layer, Stage} from "react-konva";
import BackgroundRectangleShape from "../design-editor/konva-editor/background-rectangle-shape";
import GridLayer from "../design-editor/konva-editor/grid-layer";
import BackgroundVariantImage from "../multi-variant-designer/background-variant-image";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import RenderSingleDesignVariant from "./render-single-design-variant";
import _ from "lodash";
import {DOWNLOAD_MULTI_IMAGE_TIME_DELAY} from "../../constants/design.constant";

const RenderDesignVariantList = ({
                                     designVariants,
                                     downloadAllImages,
                                     setDownloadAllImages
                                 }) => {
    const [selectedDesignVariant, setSelectedDesignVariant] = useState(null);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                if (downloadAllImages) {
                    let nextIndex = 0;
                    let existingDesignVariants = [...designVariants];
                    let currentSelectedDesignVariant: any = {...selectedDesignVariant};

                    if (currentSelectedDesignVariant) {
                        const currentIndex = _.findIndex(existingDesignVariants, ['id', currentSelectedDesignVariant?.id]);
                        nextIndex = currentIndex + 1;
                    }

                    if (existingDesignVariants && existingDesignVariants?.hasOwnProperty(nextIndex)) {
                        setSelectedDesignVariant(existingDesignVariants[nextIndex]);
                    } else {
                        setDownloadAllImages(false);
                        setSelectedDesignVariant(null);
                    }
                }

            }, DOWNLOAD_MULTI_IMAGE_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    });

    return (
        <>

            <div className="flex flex-wrap justify-start w-full mx-3">

                <div
                    className="select-images-table-container overflow-y-scroll overflow-x-scroll w-full border border-gray-300 rounded-b bg-gray-100 flex flex-wrap content-start items-start justify-center">

                    {designVariants?.map((designVariant, index) => (
                        <React.Fragment key={index}>
                            {designVariant?.batchSettings &&
                                <RenderSingleDesignVariant
                                    designVariant={designVariant}
                                    settings={designVariant?.batchSettings}
                                    selectedDesignVariant={selectedDesignVariant}
                                    variantIndex={index + 1}
                                    viewOnly={true}/>
                            }
                        </React.Fragment>
                    ))}

                </div>

            </div>

        </>
    )
}

export default RenderDesignVariantList
